import React from 'react';
import Skeleton from '../Skeleton/skeleton';
import { SkeletonWrapper } from './datePicker.style';

const skeletonDateLabels = (
  <div className='skeleton-date-label' >
    <Skeleton />
  </div>
);

const skeletonWeekLabels = (
  <div className='skeleton-week-labels' >
    <Skeleton />
  </div>
);

// const skeletonTodayButton = (
//   <div className='skeleton-today-button' >
//     <Skeleton />
//   </div>
// );

const skeletonWeek = (full: boolean, first: boolean) => {
  const classFirstHalf: string = full ? 'skeleton-week-full' : 'skeleton-week-part';
  const classSecondHalf: string = !full ? (first ? '-first' : '-last') : ''
  return (
    <div className={`${classFirstHalf}${classSecondHalf}`} >
      <Skeleton />
    </div>
  );
};

const CalendarSkeleton = (i: number) => (
  <SkeletonWrapper key={`datepicker-skeleton-${i}`}>
    { skeletonDateLabels }
    { skeletonWeekLabels }
    { skeletonWeek(false, true) }
    { skeletonWeek(true, false) }
    { skeletonWeek(true, false) }
    { skeletonWeek(true, false) }
    { skeletonWeek(false, false) }
    {/* { skeletonTodayButton } */}
  </SkeletonWrapper>
);

export default CalendarSkeleton;
